const resourceMenuItems = [
  {
    id: "marketing-opportunities-for-minority-artisans",
    label: "Marketing Opportunities for Minority Artisans",
    path: "/resources/marketing-opportunities-for-minority-artisans",
  },
  {
    id: "minority-concentrated-blocks",
    label: "Minority Concentrated Blocks",
    path: "/resources/minority-concentrated-blocks",
  },
  {
    id: "minority-concentrated-districts",
    label: "Minority Concentrated Districts",
    path: "/resources/minority-concentrated-districts",
  },
  {
    id: "impact-evaluation-study",
    label: "Impact Evaluation Study",
    path: "/resources/impact-evaluation-study",
  },
  {
    id: "resource-documents",
    label: "Resource Documents",
    path: "/resources/resource-documents",
  },
  // {
  //   id: "ksk-project-details",
  //   label: "KSK Project Details",
  //   path: "/resources/ksk-project-details",
  // },
  {
    id: "fpos-state-wise-details",
    label: "FPOs State wise details",
    path: "/resources/fpos-state-wise-details",
  },
  // {
  //   id: "lending-policy",
  //   label: "Lending Policy",
  //   path: "/resources/lending-policy",
  // },
];

export const normalizeResourceSection = (section) => {
  const matchedSection = resourceMenuItems.find((item) => item.id === section);
  return matchedSection ? matchedSection.id : resourceMenuItems[0].id;
};

export const getResourceSection = (section) =>
  resourceMenuItems.find((item) => item.id === section) || resourceMenuItems[0];

export default resourceMenuItems;
